var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_815","data-name":"Group 815","transform":"translate(41.232 32.03) rotate(180)"},[React.createElement("path",{"id":"Path_1410","data-name":"Path 1410","d":"M0,0,15.155,15.245,0,31.345","transform":"translate(24.685)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_1411","data-name":"Path 1411","d":"M39.84,0H0","transform":"translate(0 15.167)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

LeftArrow.defaultProps = {"width":"41.232","height":"32.735","viewBox":"0 0 41.232 32.735"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
